import { render, staticRenderFns } from "./BrowserDisplayAside.vue?vue&type=template&id=3c501ff2"
import script from "./BrowserDisplayAside.vue?vue&type=script&lang=js"
export * from "./BrowserDisplayAside.vue?vue&type=script&lang=js"
import style0 from "./BrowserDisplayAside.vue?vue&type=style&index=0&id=3c501ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports